export enum ModalButtonLabel {
    Save = 'save',
    Create = 'create',
    Delete = 'delete',
    Send = 'send'
}